import { Injectable } from '@angular/core';
import {AlertController, ToastController} from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(public alertController: AlertController,
              public toastController: ToastController) { }


  async presentAlert(header: string , message: string ) {
    const alert = await this.alertController.create({
      mode: 'ios',
      header,
      message,
      buttons: ['Aceptar']
    });

    await alert.present();
  }

  async presentAlertConfirm( header: string , message: string  )    {
    return new Promise(async  (resolve) => {

      const alert = await this.alertController.create({
        mode: 'ios',
        header,
        message,
        buttons: [
          {
            text: 'Cancelar',
            role: 'cancel',
            cssClass: 'secondary',
            handler: (blah) => {
              resolve(false);

            }
          }, {
            text: 'Aceptar',
            handler: () => {
              resolve(true);

            }
          }
        ]
      });

      await alert.present();
    });
  }

  async presentToast( color: string , message: string ) {
    const toast = await this.toastController.create({
      mode: 'ios',
      color,
      message,
      duration: 3000
    });
    toast.present().then();
  }

  async presentToastPosition( color: string , message: string  , position )  {
    const toast = await this.toastController.create({
      position,
      mode: 'ios',
      color,
      message,
      duration: 5000
    });
    toast.present().then();
  }
}
